import React, {useState} from "react";
import Select from "../../../elements/Select";
import TextInput from "../../../elements/TextInput";
import QDatePicker from "../../../elements/QDatePicker";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";

const EmployeeIdentityCard = ({state, identityCardProps, identityCardTypeList, identityCardTypeProps, cardHeader}) => {
  const [issueDate, setIssueDate] = useState(state.currentItem.identityCardIssueDate);
  const [expiryDate, setExpiryDate] = useState(state.currentItem.identityCardExpiryDate);

  return (
    <div className="employee-detail-card">
      <div className="employee-detail-card-header">{cardHeader}</div>
      <div className="employee-detail-card-grid">
        <div className="employee-form-field employee-span-2">
          <label htmlFor={identityCardTypeProps.itemName}>{identityCardTypeProps.label}</label>
          <Select
            label="Dokument tożsamości"
            propertyName={identityCardTypeProps.propertyName}
            required={false}
            state={state}
            itemsList={identityCardTypeList}
            itemName={identityCardTypeProps.itemName}
            displayNames={["name"]}
          />
        </div>
        <div className="employee-form-field employee-span-2">
          <label htmlFor={identityCardProps.cardId}>Seria i numer</label>
          <TextInput propertyName={identityCardProps.cardId} state={state}/>
        </div>
        <div className="employee-form-field employee-span-2">
          <label htmlFor={identityCardProps.issuedBy}>Organ wydający</label>
          <TextInput propertyName={identityCardProps.issuedBy} state={state}/>
        </div>
        <div className="employee-form-field employee-span-2">
          <label htmlFor={identityCardProps.issueLocation}>Miejsce wydania</label>
          <TextInput propertyName={identityCardProps.issueLocation} state={state}/>
        </div>
        <div className="employee-form-field employee-span-2">
          <label htmlFor={identityCardProps.cardIssueDate}>Data wydania</label>
          <QDatePicker
            pickerId="identityCardIssueDate"
            errorParagraphId="wrongCardIssueDateFormat"
            state={state}
            propertyName="identityCardIssueDate"
            startDate={issueDate}
            setStartDate={setIssueDate}
          />
          <small id="wrongCardIssueDateFormat" className="err_info offscreen employee-field-note">
            <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;Nieprawidłowy format daty
          </small>
        </div>
        <div className="employee-form-field employee-span-2">
          <label htmlFor={identityCardProps.cardExpiryDate}>Data ważności</label>
          <QDatePicker
            pickerId="identityCardExpiryDate"
            errorParagraphId="wrongIdentityCardExpiryDateFormat"
            state={state}
            propertyName="identityCardExpiryDate"
            startDate={expiryDate}
            setStartDate={setExpiryDate}
          />
          <small id="wrongIdentityCardExpiryDateFormat" className="err_info offscreen employee-field-note">
            <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;Nieprawidłowy format daty
          </small>
        </div>
      </div>
    </div>
  );
};

export default EmployeeIdentityCard;
